import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-two-column-media-left',
    templateUrl: './two-column-media-left.component.html',
    styleUrls: ['./two-column-media-left.component.scss']
})
export class TwoColumnMediaLeftComponent implements OnInit {

    @Input() icon: any = '';
    @Input() title: any = '';
    @Input() subtitle: any = '';
    @Input() description: any = '';
    @Input() url: any = '';
    @Input() thumbnail: any = '';
    @Input() width: any = '';
    @Input() button: any = 'Learn more';

    serverUrl: string = environment.webUrl;

    constructor() { }

    ngOnInit(): void {
    }

}
